import React, { useState } from "react";
import { Link } from "react-router-dom";
import api from "../api";
import toast from "react-hot-toast";
import companyLogoWhite from "../assets/images/logo-white.svg";
import { FaFacebookF, FaInstagram, FaGoogle } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

const Footer = () => {
  const [email, setEmail] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await api.post("/subscribe", { email });
      toast.success(res.data.message || "Subscribed successfully");
      setEmail("");
    } catch (err) {
      toast.error(err.response?.data?.message || "Subscription failed");
    }
  };

  return (
    <footer className="bg-gray-800 pt-10">
      <div className="max-w-screen-xl mx-auto px-4 md:px-8">
        <div className="justify-between items-center gap-12 md:flex">
          {/* Logo and social links */}
          <div className="flex-1 max-w-lg">
            <img
              src={companyLogoWhite}
              className="h-8 mb-6"
              alt="Ajo App Logo"
            />
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/ajoapp_ca" target="_blank" rel="noopener noreferrer">
                <FaFacebookF className="h-6 w-6 text-white hover:text-gray-300" aria-label="Facebook" />
              </a>
              <a href="https://www.instagram.com/ajoapp_ca" target="_blank" rel="noopener noreferrer">
                <FaInstagram className="h-6 w-6 text-white hover:text-gray-300" aria-label="Instagram" />
              </a>
              <a href="https://x.com/ajoapp_ca" target="_blank" rel="noopener noreferrer">
                <FaXTwitter className="h-6 w-6 text-white hover:text-gray-300" aria-label="X" />
              </a>
              <a href="https://share.google/nG2rnvWbJWHnzMCaD" target="_blank" rel="noopener noreferrer">
                <FaGoogle className="h-6 w-6 text-white hover:text-gray-300" aria-label="Google" />
              </a>
            </div>
          </div>

          {/* Newsletter subscription */}
          <div className="flex-1 mt-6 md:mt-0">
            <form onSubmit={handleSubmit} className="flex space-x-3">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email address"
                required
                className="flex-1 px-4 rounded-full focus:outline-none"
              />
              <button
                type="submit"
                className="px-6 py-2 text-white rounded-full bg-gray-700 hover:bg-gray-500 focus:outline-none"
              >
                Subscribe
              </button>
            </form>
          </div>
        </div>

        {/* Navigation links */}
        <div className="flex-1 mt-16 space-y-6 justify-between sm:flex md:space-y-0">
          <ul className="space-y-4 text-gray-300">
            <h4 className="text-gray-200 font-semibold sm:pb-2 border-b border-gray-200">Quick Links</h4>
            <li>
              <Link to="/" className="duration-150 hover:text-gray-400">
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/pricing"
                className="duration-150 hover:text-gray-400"
              >
                Pricing
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                className="duration-150 hover:text-gray-400"
              >
                Contact Us
              </Link>
            </li>
            <li>
              <a 
                href="https://climate.stripe.com/vvPlLF" 
                target="_blank"
                rel="noopener noreferrer"
                className="duration-150 hover:text-gray-400"
              >
                Sustainability
              </a>
            </li>
          </ul>
          <ul className="space-y-4 text-gray-300">
            <h4 className="text-gray-200 font-semibold sm:pb-2 border-b border-gray-200">Community</h4>
            <li>
              <Link
                to="/community"
                className="duration-150 hover:text-gray-400"
              >
                Community
              </Link>
            </li>
            <li>
              <Link to="/faqs" className="duration-150 hover:text-gray-400">
                FAQs
              </Link>
            </li>
            <li>
              <Link to="/about" className="duration-150 hover:text-gray-400">
                About Us
              </Link>
            </li>
          </ul>

          <ul className="space-y-4 text-gray-300">
            <h4 className="text-gray-200 font-semibold sm:pb-2 border-b border-gray-200">Legal</h4>
            <li>
              <Link
                to="/user-policy"
                className="duration-150 hover:text-gray-400"
              >
                User Policy
              </Link>
            </li>
            <li>
              <Link
                to="/termsandcondition"
                className="duration-150 hover:text-gray-400"
              >
                Terms and Conditions
              </Link>
            </li>
            <li>
              <Link
                to="/privacy"
                className="duration-150 hover:text-gray-400"
              >
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link
                to="/accessibility"
                className="duration-150 hover:text-gray-400"
              >
                Accessibility Policy
              </Link>
            </li>
          </ul>

          {/* Empty columns to maintain layout if needed */}
          <div className="hidden sm:block"></div>
          <div className="hidden sm:block"></div>
        </div>

        {/* Copyright */}
        <div className="mt-10 py-10 border-t border-gray-700 items-center justify-center sm:flex">
          <p className="text-gray-300 text-center">
            Copyright © Ajo 2024
            {/* , Designed by Craftr Studio ** Operated by The Madu Company Limited */}
          </p>
          <div className="flex items-center gap-x-6 text-gray-400 mt-6 sm:mt-0">
            {/* Additional links if needed */}
          </div>
        </div>
      </div>
</footer>
  );
};

export default Footer;
